import {
  handleGetAllMemberLastClockInOutFailure,
  handleGetAllMemberLastClockInOutRequest,
  handleGetAllMemberLastClockInOutSuccess,
} from "custom_modules/ClockInOut/clockInOutReducer";

import {
  GET_ALL_MEMBERS_LATEST_CLOCK_IN_OUT,
  GET_ALL_MEMBERS_LATEST_CLOCK_IN_OUT_FAILURE,
  GET_ALL_MEMBERS_LATEST_CLOCK_IN_OUT_SUCCESS,
  GET_LATEST_LOCATION_LIST,
  GET_LATEST_LOCATION_LIST_FAILURE,
  GET_LATEST_LOCATION_LIST_SUCCESS,
} from "../../../modules/constants";

export const getLatestLocationListRequestHandler = (state, action) => {
  return {
    ...state,
    latestLocationListLoading: true,
  };
};
export const getLatestLocationListRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      latestLocationListLoading: false,
      latestLocationList: data.data,
    };
  }
  return {
    ...state,
    latestLocationListLoading: false,
    latestLocationList: [],
  };
};

export const getLatestLocationListRequestFailureHandler = (state, action) => {
  return {
    ...state,
    latestLocationListLoading: false,
    latestLocationList: [],
  };
};

// Action Handlers
export const ACTION_HANDLERS = {
  [GET_LATEST_LOCATION_LIST]: getLatestLocationListRequestHandler,
  [GET_LATEST_LOCATION_LIST_SUCCESS]:
    getLatestLocationListRequestSuccessHandler,
  [GET_LATEST_LOCATION_LIST_FAILURE]:
    getLatestLocationListRequestFailureHandler,
  [GET_ALL_MEMBERS_LATEST_CLOCK_IN_OUT]:
    handleGetAllMemberLastClockInOutRequest,
  [GET_ALL_MEMBERS_LATEST_CLOCK_IN_OUT_SUCCESS]:
    handleGetAllMemberLastClockInOutSuccess,
  [GET_ALL_MEMBERS_LATEST_CLOCK_IN_OUT_FAILURE]:
    handleGetAllMemberLastClockInOutFailure,
};

const initialState = {
  latestLocationListLoading: false,
  latestLocationList: [],
  onlineMembers: [],
};

export default function liveLocationReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
